import i18n from '@/i18n';
import api from '@/api/i18n';

export default {
  getI18n(context, payload) {
    return api.getI18n(payload.id, payload.locale)
      .then((response) => {
        if (response.messages) {
          i18n.mergeLocaleMessage(payload.locale, response.messages);
        }
        if (response.dateTimeFormats) {
          i18n.mergeDateTimeFormat(payload.locale, response.dateTimeFormats);
        }
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/i18n/actions.js